import { useCookies } from 'react-cookie';
import Navbar from '../../../components/navbar/Navbar';
import { useCompanyContext } from '../../../context/CompanyContext';
import { useEffect, useState } from 'react';
import { filterOptions } from '@/src/utils/navBarUtil';
import { navOption } from '../../../Interfaces/system/NavBar.interfaces';

type TabsNavBarProps = {
  options: navOption[];
  rootPath: string;
};

const TabsNavBar = ({ options, rootPath }: TabsNavBarProps) => {
  const { selectedCompany } = useCompanyContext();
  const [tabOptions, setTabOptions] = useState(
    filterOptions(options, selectedCompany)
  );
  const cookiesMethods = useCookies(['filters']);

  const onOptionClick = () => {
    const remove = cookiesMethods[2];
    remove('filters', { path: rootPath });
  };

  useEffect(() => {
    setTabOptions(filterOptions(options, selectedCompany));
  }, [selectedCompany, options]);

  return <Navbar options={tabOptions} onOptionClick={onOptionClick} />;
};

export default TabsNavBar;
